import { Helmet } from "react-helmet";
import * as React from "react";

export const AgentHelmet = () => (
  <Helmet>
    <title>{"Kahun Diagnostic Agent"}</title>
    <meta name="description" content={`Use the Kahun Diagnostic Agent`} />
  </Helmet>
);
